<template>
  <v-card class="pa-4 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth">
    <v-row>
      <v-col cols="12" class="pb-0">
        <div class="font-size-12 cl-grey font-weight-500">Bonus Potency</div>
      </v-col>
    </v-row>

    <v-row class="ml-0">
      <v-col class="pl-0" v-if="false">
        <v-card class="rounded-xl blue lighten-4 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-wallet</v-icon>
            <div class="cl-grey font-size-11 text-capitalize ml-1">Node Bonus</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="">
            <div v-if="userData.member_id == '1'" class="pl-1 font-size-14 cl-primary font-weight-bold">{{ 0 | toCurrencyFormat }}</div>
            <div v-else class="pl-1 font-size-14 cl-primary font-weight-bold">{{ potency.bonus_node | toCurrencyFormat }}</div>
          </v-col>
        </v-card>
      </v-col>
      <v-col class="pl-0">
        <v-card class="rounded-xl blue lighten-4 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-wallet</v-icon>
            <div class="cl-grey font-size-11 text-capitalize ml-1">Sponsor Bonus</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="">
            <div v-if="userData.member_id == '1'" class="pl-1 font-size-14 cl-primary font-weight-bold">{{ 0 | toCurrencyFormat }}</div>
            <div v-else class="pl-1 font-size-14 cl-primary font-weight-bold">{{ potency.bonus_sponsor | toCurrencyFormat }}</div>
          </v-col>
        </v-card>
      </v-col>
      <v-col class="pl-0">
        <v-card class="rounded-xl blue lighten-4 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-wallet</v-icon>
            <div class="cl-grey font-size-11 text-capitalize ml-1">Pairing Bonus</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="">
            <div v-if="userData.member_id == '1'" class="pl-1 font-size-14 cl-primary font-weight-bold">{{ 0 | toCurrencyFormat }}</div>
            <div v-else class="pl-1 font-size-14 cl-primary font-weight-bold">{{ potency.bonus_match | toCurrencyFormat }}</div>
          </v-col>
        </v-card>
      </v-col>
      <v-col class="pl-0">
        <v-card class="rounded-xl blue lighten-4 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-wallet</v-icon>
            <div class="cl-grey font-size-11  text-capitalize ml-1">Cashback Bonus</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="">
            <div v-if="userData.member_id == '1'" class="pl-1 font-size-14 cl-primary font-weight-bold">{{ 0 | toCurrencyFormat }}</div>
            <div v-else class="pl-1 font-size-14 cl-primary font-weight-bold">{{ potency.bonus_cashback | toCurrencyFormat }}</div>
          </v-col>
        </v-card>
      </v-col>
      <v-col class="pl-0">
        <v-card class="rounded-xl blue lighten-4 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-wallet</v-icon>
            <div class="cl-grey font-size-11 text-capitalize ml-1">Unilevel Bonus</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="">
            <div v-if="userData.member_id == '1'" class="pl-1 font-size-14 cl-primary font-weight-bold">{{ 0 | toCurrencyFormat }}</div>
            <div v-else class="pl-1 font-size-14 cl-primary font-weight-bold">{{ potency.bonus_unilevel | toCurrencyFormat }}</div>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

export default {
  data() {
    return {
      userData: {},
      loading: false
		}
  },
  props: {
    potency: Object,
    country: String,
  },
  mounted() {
    this.loading = true;
    const authData = localStorage.getItem('mlmcore-vo-auth-data');
    this.userData = JSON.parse(authData)
  },
}
</script>